"use strict";

var _interopRequireDefault = require("/codebuild/output/src3029718028/src/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.find.js");
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/esnext.json.parse.js");
var _log = require("@/utils/log");
var _momentTimezone = _interopRequireDefault(require("moment-timezone"));
var _lifehikesInitData = require("@/lifehikes-init-data");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: "ScheduleEventTime",
  props: {
    start: {
      type: Object
    },
    end: {
      type: Object
    },
    isRequired: {
      type: Boolean,
      default: false
    },
    startPlaceholder: {
      type: String,
      default: "UTC Start Time"
    },
    endPlaceholder: {
      type: String,
      default: "UTC End Time"
    },
    recur: {
      type: String,
      default: ""
    }
  },
  created() {
    if (this.startTime.utc !== "" || this.endTime.utc !== "") {
      if (this.startTime.utc !== "") {
        const offset = this.startTime.timezone;
        const local = this.startTime.local;
        const timeZoneObj = this.initTimeZone(offset, local);
        console.info(timeZoneObj);
        this.setSelectTimeZone(timeZoneObj.offset, timeZoneObj.gmt, 'start');
      }
      if (this.endTime.utc !== "") {
        const offset = this.endTime.timezone;
        const local = this.endTime.local;
        const timeZoneObj = this.initTimeZone(offset, local);
        console.info(timeZoneObj);
        this.setSelectTimeZone(timeZoneObj.offset, timeZoneObj.gmt, 'end');
      }
    } else {
      //Cache is enabled by default. If not, use moment.tz.guess(true)
      const offset = _momentTimezone.default.tz.guess();
      const local = '';
      const timeZoneObj = this.initTimeZone(offset, local);
      console.info(timeZoneObj);
      this.setSelectTimeZone(timeZoneObj.offset, timeZoneObj.gmt, 'start');
      this.setSelectTimeZone(timeZoneObj.offset, timeZoneObj.gmt, 'end');
    }
  },
  data() {
    return {
      startTime: JSON.parse(JSON.stringify(this.start)),
      endTime: JSON.parse(JSON.stringify(this.end)),
      timeZoneList: _lifehikesInitData.salesForceTimeZone,
      startTimeZome: "",
      endTimeZome: ""
    };
  },
  watch: {
    start: {
      handler(newVal) {
        (0, _log.showDebugLog)("valChange", newVal);
        const start = JSON.parse(JSON.stringify(newVal));
        this.startTime = start;
        if (newVal) {
          const offset = newVal.timezone;
          const local = newVal.local;
          const timeZoneObj = this.initTimeZone(offset, local);
          console.info(timeZoneObj);
          this.setSelectTimeZone(timeZoneObj.offset, timeZoneObj.gmt, 'start');
        }
      },
      deep: true
    },
    end: {
      handler(newVal) {
        (0, _log.showDebugLog)("valChange", newVal);
        const end = JSON.parse(JSON.stringify(newVal));
        this.endTime = end;
        if (newVal) {
          const offset = newVal.timezone;
          const local = newVal.local;
          const timeZoneObj = this.initTimeZone(offset, local);
          console.info(timeZoneObj);
          this.setSelectTimeZone(timeZoneObj.offset, timeZoneObj.gmt, 'end');
        }
      },
      deep: true
    }
  },
  methods: {
    setTimeZone(e) {
      (0, _log.showDebugLog)("select timezone value", e);
      const timeZoneList = JSON.parse(JSON.stringify(_lifehikesInitData.salesForceTimeZone));
      const currentTimeZone = timeZoneList.find(p => p.label === e);
      this.startTimeZome = currentTimeZone.label;
      this.endTimeZome = currentTimeZone.label;
      this.startTime.timezone = currentTimeZone.offset;
      this.endTime.timezone = currentTimeZone.offset;
      console.info(this.startTimeZome);
      console.info(this.endTimeZome);
      this.setUtcTime(this.startTime.local, "start");
      this.setUtcTime(this.endTime.local, "end");
    },
    setUtcTime(e, dtype) {
      if (dtype === "start") {
        if (e) {
          const offset = this.startTime.timezone;
          const local = this.startTime.local;
          const timeZoneObj = this.initTimeZone(offset, local);
          console.info(timeZoneObj);
          //this.setSelectTimeZone(timeZoneObj.offset, timeZoneObj.gmt, 'start')
          this.startTime.utc = timeZoneObj.utcDate;
        } else {
          this.startTime.utc = "";
          this.startTime.local = "";
        }
        this.$emit('update:start', this.startTime);
        (0, _log.showDebugLog)("utc-start", this.startTime.utc);
      }
      if (dtype === "end" && e !== "" && e !== null) {
        if (e) {
          const offset = this.endTime.timezone;
          const local = this.endTime.local;
          const timeZoneObj = this.initTimeZone(offset, local);
          console.info(timeZoneObj);
          //this.setSelectTimeZone(timeZoneObj.offset, timeZoneObj.gmt, 'end')
          this.endTime.utc = timeZoneObj.utcDate;
        } else {
          this.endTime.utc = "";
          this.endTime.local = "";
        }
        this.$emit('update:end', this.endTime);
        (0, _log.showDebugLog)("utc-end", this.endTime.utc);
      }
    },
    setSelectTimeZone(offset, gmt, dtype) {
      const timeZoneList = JSON.parse(JSON.stringify(_lifehikesInitData.salesForceTimeZone));
      if (dtype === "start") {
        const currentTimeZone = timeZoneList.find(p => p.offset === offset && p.gmt === gmt);
        this.startTimeZome = currentTimeZone.label;
        this.startTime.timezone = currentTimeZone.offset;
        console.info(currentTimeZone);
      }
      if (dtype === "end") {
        const currentTimeZone = timeZoneList.find(p => p.offset === offset && p.gmt === gmt);
        this.endTimeZome = currentTimeZone.label;
        this.endTime.timezone = currentTimeZone.offset;
        console.info(currentTimeZone);
      }
    },
    initTimeZone(offset, local) {
      console.info("当前选中的时区：" + offset);
      console.info("当前选中时区的本地时间：" + local);
      let localDate = "";
      if (local === '' || local === undefined) {
        localDate = (0, _momentTimezone.default)().parseZone(offset).local().format("YYYY-MM-DD HH:mm:ss").toString();
        localDate = _momentTimezone.default.tz(localDate, offset);
      } else {
        localDate = (0, _momentTimezone.default)(local).format("YYYY-MM-DD HH:mm:ss").toString();
        localDate = _momentTimezone.default.tz(localDate, offset);
      }
      console.info("localDate：" + localDate.format("YYYY-MM-DD HH:mm:ss"));
      const gmt = localDate.format('Z');
      console.info("gmt：" + gmt);
      const utcDate = localDate.utc().format();
      console.info("utcDate:" + utcDate);
      return {
        offset: offset,
        gmt: gmt,
        utcDate: utcDate
      };
    }
  }
};